var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.83342L3.65333 3.97475C3.75622 3.73475 3.9273 3.53024 4.14537 3.3866C4.36344 3.24296 4.61888 3.16652 4.88 3.16675H11.1213C11.3822 3.16678 11.6374 3.24335 11.8552 3.38697C12.073 3.53059 12.2439 3.73496 12.3467 3.97475L14 7.83342M2 7.83342H14M2 7.83342V12.5001M14 7.83342V12.5001M12 12.5001V12.8334C12 13.0986 12.1054 13.353 12.2929 13.5405C12.4804 13.7281 12.7348 13.8334 13 13.8334C13.2652 13.8334 13.5196 13.7281 13.7071 13.5405C13.8946 13.353 14 13.0986 14 12.8334V12.5001M12 12.5001H4M12 12.5001H14M4 12.5001V12.8334C4 13.0986 3.89464 13.353 3.70711 13.5405C3.51957 13.7281 3.26522 13.8334 3 13.8334C2.73478 13.8334 2.48043 13.7281 2.29289 13.5405C2.10536 13.353 2 13.0986 2 12.8334V12.5001M4 12.5001H2M4.66667 9.83342H4.66733M11.3333 9.83342H11.334",
    stroke: "#7D7D7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarOutlined);
export default __webpack_public_path__ + "static/media/car-outlined.6bff1223005fdf6401ffa943241e8e16.svg";
export { ForwardRef as ReactComponent };